/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { FormattedNumber } from "react-intl";

interface IOrderSummaryProps {
  totalPayment: any;
  items: any[];
}

interface IOrderSummaryState {
  shouldRedirect: boolean;
}

export default class OrderSummary extends React.Component<
  IOrderSummaryProps,
  IOrderSummaryState
> {
  constructor(props: IOrderSummaryProps) {
    super(props);
    this.state = {
      shouldRedirect: false,
    };
  }

  getSummaryModifier(item: any, parent: any) {
    return (
      <li key={`${item.id}-${item.parentItemId}-${parent.id}`}>
        {item.name} {item.perItemPrice.currencySymbol}
        <FormattedNumber
          minimumFractionDigits={2}
          value={item.perItemPrice.amount || 0}
        />
      </li>
    );
  }

  getSummaryItem(item: any, index: number) {
    if (item.parentItemId == null) {
      const modifiers = this.props.items
        .filter((modifier: any) => modifier.parentItemId === item.id)
        .slice()
        .sort((a: any, b: any) => a.name.localeCompare(b.name));

      return (
        <tr key={item.name + index} style={{ lineHeight: "normal" }}>
          <td className="width-1">
            <div className="item-title">{item.name}</div>
            {modifiers.length > 0 && (
              <ul>
                {modifiers.map((modifier: any) =>
                  this.getSummaryModifier(modifier, item)
                )}
              </ul>
            )}
          </td>
          <td className="width-2">
            <span className="amount">{item.quantity}x</span>
          </td>
          <td className="width-3">
            <span className="item-price">
              {item.perItemPrice.currencySymbol}
              <FormattedNumber
                minimumFractionDigits={2}
                value={item.perItemPrice.amount || 0}
              />
            </span>
          </td>
        </tr>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <table className="table table-summary">
        <thead>
          <tr>
            <th className="title" colSpan={3}>
              Please Check Your Order
            </th>
          </tr>
        </thead>
        <tbody>
          {this.props.items.map((item: any, index: number) =>
            this.getSummaryItem(item, index)
          )}
        </tbody>
      </table>
    );
  }
}
